import { render, staticRenderFns } from "./FoodDistributionAddFamily.vue?vue&type=template&id=32ca196a&"
import script from "./FoodDistributionAddFamily.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionAddFamily.vue?vue&type=script&lang=js&"
import style0 from "./FoodDistributionAddFamily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports